import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export interface TranslationToDelete {
  id: number;
  product: string;
  mavenVersion: string;
  targetLanguage: string;
}

type DeletionResult =
  | { confirmationRequired: true; translations: TranslationToDelete[] }
  | { confirmationRequired: false; translation: Translation | null };

export const deleteTranslation = async (
  translationId: number,
  confirmedTranslationIds: number[] = []
): Promise<DeletionResult> => {
  const params = new URLSearchParams();
  confirmedTranslationIds.forEach((id) => params.append("confirmedTranslationId", String(id)));
  const response = await axiosInstance.delete<ApiResponse<Translation | TranslationToDelete[]>>(
    `/api/translation/delete/${translationId}`,
    {
      params,
      validateStatus: (status) => (status >= 200 && status < 300) || status === 409,
    }
  );
  if (response.status === 409) {
    const translations = response.data.data;
    if (
      !Array.isArray(translations) || translations.length === 0 ||
      !translations.every((translation) =>
        translation != null && Number.isSafeInteger(translation.id) && translation.id > 0 &&
        typeof translation.product === "string" && typeof translation.mavenVersion === "string" &&
        typeof translation.targetLanguage === "string"
      )
    ) {
      throw new Error("The server returned an invalid deletion confirmation list.");
    }
    return { confirmationRequired: true, translations };
  }
  if (Array.isArray(response.data.data)) {
    throw new Error("The server returned an invalid deletion response.");
  }
  return { confirmationRequired: false, translation: response.data.data };
};
